import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FaqComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    // Initialize accordion functionality
    this.initAccordion();
  }

  initAccordion(): void {
    // Add click event listeners to accordion headers
    setTimeout(() => {
      const accordionHeaders = document.querySelectorAll('.accordion-header');
      accordionHeaders.forEach(header => {
        header.addEventListener('click', () => {
          const item = header.parentElement;
          const icon = header.querySelector('.accordion-icon i');
          
          // Toggle active class
          item.classList.toggle('active');
          
          // Toggle icon
          if (item.classList.contains('active')) {
            icon.classList.remove('bx-plus');
            icon.classList.add('bx-minus');
          } else {
            icon.classList.remove('bx-minus');
            icon.classList.add('bx-plus');
          }
        });
      });
    }, 0);
  }
}